._1q2klnm0 {
  display: flex;
  flex-direction: column;
}
._1q2klnm1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  flex: 1 1 0%;
}
._1q2klnm2 {
  justify-content: start;
  margin: 70px 0;
}
._1q2klnm3 {
  margin-top: 24px;
  margin-bottom: 20px;
}
@media screen and (min-width: 768px) {
  ._1q2klnm3 {
    margin-top: 35px;
    margin-bottom: 24px;
  }
}